import { ShieldCheckIcon } from '@heroicons/react/24/outline';

export const roleConfig = {
  title: 'Role',
  endpoint: 'admin/roles',
  storageKey: 'roles',
  icon: ShieldCheckIcon,
  useUrlNavigation: true,
  basePath: '/admin/roles',

  columns: [
    { key: 'name', label: 'Role Name', render: (item) => <span className="font-medium">{item.name}</span> },
    { key: 'description', label: 'Description', render: (item) => item.description || '—' },
    {
      key: 'permissions',
      label: 'Modules',
      render: (item) => {
        const modules = Object.keys(item.permissions || {});
        if (!modules.length) return <span className="text-gray-400 text-sm">No permissions</span>;
        return (
          <div className="flex flex-wrap gap-1">
            {modules.slice(0, 4).map((m) => (
              <span key={m} className="px-2 py-0.5 bg-blue-100 text-blue-700 text-xs rounded-full">{m}</span>
            ))}
            {modules.length > 4 && (
              <span className="px-2 py-0.5 bg-gray-100 text-gray-500 text-xs rounded-full">+{modules.length - 4}</span>
            )}
          </div>
        );
      },
    },
  ],

  formFields: [
    { name: 'name', label: 'Role Name', type: 'text', required: true, placeholder: 'e.g. Center Manager' },
    { name: 'description', label: 'Description', type: 'text', placeholder: 'Optional description' },
  ],

  searchFields: ['name', 'description'],
};
